import * as React from 'react';
import { connect } from 'react-redux';
import IconButton from '../common/IconButton';
import NewToolbarItemScroller from '../common/toolbar-item-scroller/NewToolbarItemScroller';
import { Dispatch, Action } from 'redux';
import UIAction from '../../actions/ui/UIAction';
import { CurrentTool } from '../../reducers/ui/ui';
import CurrentToolIcon from '../header-toolbar/CurrentToolIcon';

interface HeaderToolbarSelectionLevelProps {
  readonly isVertical: boolean;
  readonly popToTopLevel: () => void;
  readonly dispatch: Dispatch<Action>;
}

const HeaderToolbarSelectionLevel: React.SFC<
  HeaderToolbarSelectionLevelProps
> = React.memo((props) => {
  const { isVertical, dispatch } = props;

  return <>
    <CurrentToolIcon />

    <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
      <IconButton
        title="ズーム/パン+紙面操作"
        imagePath="images/tool-icons/new/zoompan/zoompan"
        onClick={() => UIAction.setCurrentTool(CurrentTool.Touch, dispatch)} />
      <IconButton
        title="オブジェクト選択"
        imagePath="images/tool-icons/new/object_selection/object_selection"
        rouondRect={true}
        onClick={() => {
          UIAction.setCurrentTool(CurrentTool.ObjectSelection, dispatch);
        }} />
      <IconButton
        title="テキスト選択"
        imagePath="images/tool-icons/new/txt_select/txt_select"
        onClick={() => UIAction.setCurrentTool(CurrentTool.Mouse, dispatch)} />
    </NewToolbarItemScroller>

    <IconButton
      title="戻る"
      imagePath="images/tool-icons/new/btn_top/btn_top"
      rouondRect={true}
      onClick={props.popToTopLevel} />
  </>;
});

export default connect()(HeaderToolbarSelectionLevel);
